/**
 * Hero background video loader.
 * - Skips on mobile: hero background videos can be 10+ MB and most mobile browsers
 *   block autoplay anyway, so loading them only burns bandwidth and LCP.
 * - On desktop, defers the iframe src assignment until the browser is idle so the
 *   video does not compete with the LCP element for bandwidth or main-thread time.
 */

export default function (rootEl) {
    if (window.matchMedia('(max-width: 1023px)').matches) {
        return;
    }

    const loadVideos = () => {
        const resourceVideoEls = document.querySelectorAll('.js-hero-video-player');
        resourceVideoEls.forEach(resourceVideoEl => {
            const iframeSrcTemplate = resourceVideoEl.getAttribute('data-src');
            const videoId = resourceVideoEl.getAttribute('data-video-id');
            if (iframeSrcTemplate) {
                resourceVideoEl.src = iframeSrcTemplate.replace('[ID]', videoId);
            }
        });
    };

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadVideos, { timeout: 3000 });
    } else {
        setTimeout(loadVideos, 1500);
    }
};